import React from 'react';
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';
import { withRouter } from 'react-router'

var devices = ''
//var device = ''

export default class modify_device_settings extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sn: '',
      location: '',
      locations: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      business_name: '',
      street_address: '',
      city: '',
      state: '',
      zip_code: '',
      country: '',
      timezone: 'America/New_York',
      location_type: 'retail',
      number_people: '20',
      reset_time: '4:00',
      number_songs: '5',
      song_start: '1980',
      song_end: '1999',
      start_time: '7:00',
      stop_time: '20:00',
      camera_type: 'ip_cam',
      rstp_address: 'rstp://username:password@192.168.1.xxx:554/live/ch0',
      device: '',
      devices: ''
    };

    this.update_sn = this.update_sn.bind(this);
    this.update_location = this.update_location.bind(this);
    this.update_first_name = this.update_first_name.bind(this);
    this.update_last_name = this.update_last_name.bind(this);
    this.update_email = this.update_email.bind(this);
    this.update_phone_number = this.update_phone_number.bind(this);
    this.update_business_name = this.update_business_name.bind(this);
    this.update_street_address = this.update_street_address.bind(this);
    this.update_city = this.update_city.bind(this);
    this.update_state = this.update_state.bind(this);
    this.update_zip_code = this.update_zip_code.bind(this);
    this.update_country = this.update_country.bind(this);
    this.update_timezone = this.update_timezone.bind(this);
    this.update_location_type = this.update_location_type.bind(this);
    this.update_number_people = this.update_number_people.bind(this);
    this.update_reset_time = this.update_reset_time.bind(this);
    this.update_number_songs = this.update_number_songs.bind(this);
    this.update_song_start = this.update_song_start.bind(this);
    this.update_song_end = this.update_song_end.bind(this);
    this.update_start_time = this.update_start_time.bind(this);
    this.update_stop_time = this.update_stop_time.bind(this);
    this.update_camera_type = this.update_camera_type.bind(this);
    this.update_rstp_address = this.update_rstp_address.bind(this);
    this.update_fields = this.update_fields.bind(this);
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

    componentDidMount() {
       try{
           var xhr1 = new XMLHttpRequest()
		   xhr1.addEventListener('load', () => {
		   this.data = JSON.parse(xhr1.responseText);//parse response text into data object
		   console.log("response from server: " + this.data.result);
		   console.log("sn: " + this.data.sn[0]);
		   this.setState({ sn: this.data.sn[0]});
		   this.state.devices = this.data.sn
		   devices = this.data.sn
		   this.state.device = this.state.devices[0]
		   this.state.sn = this.state.devices[0]
		   this.setState({ sn: this.state.devices[0]});
		   this.setState({ locations: this.data.location_desc});
		   console.log('locations:' + this.data.location_desc)
		   var select_item = document.getElementById("device_selector")
		   var option = document.createElement("option")
				 try{
					 for(var i=0;i<this.data.sn.length;i++){
						 option = document.createElement("option")
						 option.text = this.data.sn[i]// + ' --- ' + this.data.location_desc[i]
						 option.value = this.data.sn[i]
						 select_item.add(option)

						 }
				 }catch(error){
					 console.log(error)
				 }

				 this.update_fields();

				})
			xhr1.open('POST', 'http://3.21.222.196:3035/get_devices');//87 is considered unsafe by Chrome
			xhr1.setRequestHeader("Content-Type", "application/json");
			xhr1.send(JSON.stringify({'email': this.readCookie('email')}));

       }catch(error){
              this.props.history.push({
               pathname: '/user_menu'
              })

       }






     //console.log(this.props.location.state.email)
     try {
     console.log(window.globalEmail)
     console.log(window.globalPassword)
     console.log(window.globalFirstName)
     console.log(window.globalLastName)
     this.setState.email = window.globalEmail;
     this.setState.first_name = window.globalFirstName;
     this.setState.last_name = window.globalLastName;

//     console.log(this.props.location.state.email)
//     console.log(this.props.location.state.password)
//     console.log(this.props.location.state.first_name)
//     console.log(this.props.location.state.last_name)
     if (typeof window.globalEmail === 'undefined'){
          window.globalPath = 'modify_device_settings'
          this.props.history.push({
          pathname: '/login'
          })
     }else{
//          document.getElementById('email_address').value = window.globalEmail;
//          this.setState.email = window.globalEmail;
//          document.getElementById('first_name').value = window.globalFirstName;
//          this.setState.first_name = window.globalFirstName;
//          document.getElementById('last_name').value = window.globalLastName;
//          this.setState.last_name = window.globalLastName;



//          this.setState({ email_address: this.props.location.state.email });
//          this.setState({ password: this.props.location.state.password });
//          document.getElementById('email_address').value = this.props.location.state.email;
//          this.state.email = this.props.location.state.email;
//          document.getElementById('first_name').value = this.props.location.state.first_name;
//          this.state.first_name = this.props.location.state.first_name;
//          document.getElementById('last_name').value = this.props.location.state.last_name;
//          this.state.last_name = this.props.location.state.last_name;
     }


     //document.getElementById('email_address').value = this.props.location.state.email;

     //document.getElementById('password').value = this.props.location.state.password
     } catch (e) {
          console.log('Error getting state - go to login')

          }


  }//end of componentDidMount

  update_fields(){
      try{
           var select_item = document.getElementById("device_selector")
           this.setState({ sn: select_item.value});
           this.setState({ device: select_item.value});
           console.log(select_item.selectedIndex);
           var xhr2 = new XMLHttpRequest()
           xhr2.addEventListener('load', () => {
           this.data = JSON.parse(xhr2.responseText);//parse response text into data object
           console.log("response from server: " + this.data.result);
           console.log("device_data: " + this.data.device_data);
           console.log("phone_number: " + this.data.device_data[0][6]);


           try{

           this.setState({ location: this.data.device_data[0][2]});
           document.getElementById('location').value = this.state.location
           this.setState({ first_name: this.data.device_data[0][3]});
           document.getElementById('first_name').value = this.state.first_name
           this.setState({ last_name: this.data.device_data[0][4]});
           document.getElementById('last_name').value = this.state.last_name
           this.setState({ email: this.data.device_data[0][5]});
           document.getElementById('email_address').value = this.state.email
           this.setState({ phone_number: this.data.device_data[0][6]});
           document.getElementById('phone_number').value = this.state.phone_number
           this.setState({ business_name: this.data.device_data[0][7]});
           document.getElementById('business_name').value = this.state.business_name
           this.setState({ street_address: this.data.device_data[0][8]});
           document.getElementById('street_address').value = this.state.street_address
           this.setState({ city: this.data.device_data[0][9]});
           document.getElementById('city').value = this.state.city
           this.setState({ state: this.data.device_data[0][10]});
           document.getElementById('state').value = this.state.state
           this.setState({ zip_code: this.data.device_data[0][11]});
           document.getElementById('zip_code').value = this.state.zip_code
           this.setState({ country: this.data.device_data[0][12]});
           document.getElementById('country').value = this.state.country

           var count = document.getElementById('timezone').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 console.log(document.getElementById('timezone').options[i].value)
                 console.log(this.data.device_data[0][13])
                 if (document.getElementById('timezone').options[i].value == this.data.device_data[0][13]){
                     console.log(document.getElementById('timezone').options[i].value)
                     console.log(this.data.device_data[0][13])
                     document.getElementById('timezone').selectedIndex = i
                     this.setState({ timezone: this.data.device_data[0][13]});
                     }
                 }

           var count = document.getElementById('location_type').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('location_type').options[i].value == this.data.device_data[0][14]){
                     document.getElementById('location_type').selectedIndex = i
                     this.setState({ location_type: this.data.device_data[0][14]});
                     }
                 }

           var count = document.getElementById('people_qty').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('people_qty').options[i].value == this.data.device_data[0][15]){
                     document.getElementById('people_qty').selectedIndex = i
                     this.setState({ number_people: this.data.device_data[0][15]});
                     }
                 }

           var count = document.getElementById('number_songs').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('number_songs').options[i].value == this.data.device_data[0][17]){
                     document.getElementById('number_songs').selectedIndex = i
                     this.setState({ number_songs: this.data.device_data[0][17]});
                     }
                 }

            var count = document.getElementById('reset_time').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('reset_time').options[i].value == this.data.device_data[0][16]){
                     document.getElementById('reset_time').selectedIndex = i
                     this.setState({ reset_time: this.data.device_data[0][16]});
                     }
                 }


           var count = document.getElementById('song_start').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('song_start').options[i].value == this.data.device_data[0][18]){
                     document.getElementById('song_start').selectedIndex = i
                     this.setState({ song_start: this.data.device_data[0][18]});
                     }
                 }

           var count = document.getElementById('song_end').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('song_end').options[i].value == this.data.device_data[0][19]){
                     document.getElementById('song_end').selectedIndex = i
                     this.setState({ song_end: this.data.device_data[0][19]});
                     }
                 }

           var count = document.getElementById('start_time').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('start_time').options[i].value == this.data.device_data[0][21]){
                     document.getElementById('start_time').selectedIndex = i
                     this.setState({ start_time: this.data.device_data[0][21]});
                     }
                 }

           var count = document.getElementById('stop_time').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('stop_time').options[i].value == this.data.device_data[0][22]){
                     document.getElementById('stop_time').selectedIndex = i
                     this.setState({ stop_time: this.data.device_data[0][22]});
                     }
                 }

           var count = document.getElementById('camera_type').options.length
           // console.log('drop down count: ' + count)
             for(var i=0;i<count;i++){
                 //console.log(document.getElementById('timezone').options[i].value)
                 //console.log(this.data.device_data[0][13])
                 if (document.getElementById('camera_type').options[i].value == this.data.device_data[0][23]){
                     document.getElementById('camera_type').selectedIndex = i
                     this.setState({ camera_type: this.data.device_data[0][23]});
                     }
                 }

           this.setState({ rstp_address: this.data.device_data[0][24]});
           document.getElementById('rstp_address').value = this.state.rstp_address

           }catch(error){

           }

                })
        xhr2.open('POST', 'http://3.21.222.196:3035/get_device_data');//87 is considered unsafe by Chrome
        xhr2.setRequestHeader("Content-Type", "application/json");
        console.log("device: " + devices[select_item.selectedIndex]);
        xhr2.send(JSON.stringify({'serial_number': devices[select_item.selectedIndex].toString()}));

       }catch(error){
              this.props.history.push({
               //pathname: '/modify_device_settings'
              })

       }
  }

  update_sn(event) {
    this.setState({ sn: event.target.value });
    //console.log(this.state.sn);
  }

  update_location(event) {
    this.setState({ location: event.target.value });
    //console.log(this.state.location);
  }

  update_first_name(event) {
    this.setState({ first_name: event.target.value });
  }

  update_last_name(event) {
    this.setState({ last_name: event.target.value });
  }

  update_email(event) {
    this.setState({ email: event.target.value });
  }

  update_phone_number(event) {
    this.setState({ phone_number: event.target.value });
  }

  update_business_name(event) {
    this.setState({ business_name: event.target.value });
  }

  update_street_address(event) {
    this.setState({ street_address: event.target.value });
  }

  update_city(event) {
    this.setState({ city: event.target.value });
  }

  update_state(event) {
    this.setState({ state: event.target.value });
  }

  update_zip_code(event) {
    this.setState({ zip_code: event.target.value });
  }

  update_country(event) {
    this.setState({ country: event.target.value });
  }

  update_timezone(event) {
    this.setState({ timezone: event.target.value });
  }

  update_location_type(event) {
    this.setState({ location_type: event.target.value });
  }

  update_number_people(event) {
    this.setState({ number_people: event.target.value });
  }

 update_reset_time(event) {
    this.setState({ reset_time: event.target.value });
  }

  update_number_songs(event) {
    this.setState({ number_songs: event.target.value });
  }

  update_song_start(event) {
    this.setState({ song_start: event.target.value });
  }

  update_song_end(event) {
    this.setState({ song_end: event.target.value });
  }

  update_start_time(event) {
    this.setState({ start_time: event.target.value });
  }

  update_stop_time(event) {
    this.setState({ stop_time: event.target.value });
  }

  update_camera_type(event) {
    this.setState({ camera_type: event.target.value });
  }

  update_rstp_address(event) {
    this.setState({ rstp_address: event.target.value });
  }

  handleClick = () => {
    //console.log('click');
    console.log(this.state.sn);
    console.log(this.state.location);
    console.log(this.state.first_name);
    console.log(this.state.last_name);
    console.log(this.state.email);
    console.log(document.getElementById('email_address').value)
    console.log(this.state.phone_number);
    console.log(this.state.business_name);
    console.log(this.state.street_address);
    console.log(this.state.city);
    console.log(this.state.state);
    console.log(this.state.zip_code);
    console.log(this.state.country);
    console.log(this.state.timezone);
    console.log(this.state.location_type);
    console.log(this.state.number_people);
    console.log(this.state.number_songs);
    console.log(this.state.song_start);
    console.log(this.state.song_end);
    console.log(this.state.stop_time);
    console.log(this.state.start_time);
    console.log(this.state.camera_type);
    console.log(this.state.rstp_address);

//    this.setState.email = window.globalEmail;
//    this.setState.first_name = window.globalFirstName;
//    this.setState.last_name = window.globalLastName;

    console.log(this.state.sn)
    if (this.state.sn.length === 0 || this.state.location.length === 0 || document.getElementById('first_name').value === 0 || document.getElementById('last_name').value === 0 || document.getElementById('email_address').value=== 0 || +
      this.state.phone_number.length === 0 || this.state.business_name.length === 0 || this.state.street_address.length === 0 || this.state.city.length === 0 || +
      this.state.state.length === 0 || this.state.zip_code.length === 0 || this.state.country.length === 0 || this.state.number_songs.length === 0 || +
      this.state.song_start.length === 0 || this.state.song_end.length === 0 || this.state.start_time.length === 0 ||this.state.stop_time.length === 0 ||this.state.camera_type.length === 0 || this.state.rstp_address.length === 0) {
      var fields = "";
      if (this.state.sn.length === 0) {
        fields = "Serial Number\n";
      }
      if (this.state.location.length === 0) {
        fields += "Location\n";
      }
      if (document.getElementById('first_name').value === 0) {
        fields += "First Name\n";
      }
      if (document.getElementById('last_name').value=== 0) {
        fields += "Last Name\n";
      }
      if (document.getElementById('email_address').value === 0) {
        fields += "Email Address\n";
      }
      if (this.state.phone_number.length === 0) {
        fields += "Phone Number\n";
      }
      if (this.state.business_name.length === 0) {
        fields += "Business Name\n";
      }
      if (this.state.street_address.length === 0) {
        fields += "Street Address\n";
      }
      if (this.state.city.length === 0) {
        fields += "City\n";
      }
      if (this.state.state.length === 0) {
        fields += "State\n";
      }
      if (this.state.zip_code.length === 0) {
        fields += "Zip Code\n";
      }
      if (this.state.country.length === 0) {
        fields += "Country\n";
      }
      if (this.state.number_songs.length === 0) {
        fields += "Number of songs\n";
      }
      if (this.state.song_start.length === 0) {
        fields += "Song start\n";
      }
      if (this.state.song_start.length === 0) {
        fields += "Song end\n";
      }
      if (this.state.start_time.length === 0) {
        fields += "Start time\n";
      }
      if (this.state.stop_time.length === 0) {
        fields += "Stop time\n";
      }
      if (this.state.camera_type.length === 0) {
        fields += "Camera Type\n";
      }
      if (this.state.rstp_address.length === 0) {
        fields += "RSTP Address\n";
      }

      alert("The following fields are missing\n" + fields)
    } else {
      var xhr1 = new XMLHttpRequest()
      xhr1.addEventListener('load', () => {
        var data = JSON.parse(xhr1.responseText);//parse response text into data object
        //console.log("collage_map from MPS1: " + data.collage_map_mex);
        console.log("response from server: " + data.result);
        if (data.result === "OK") {
          alert("Thank you for updating your device settings!")
          this.props.history.push({
               pathname: '/user_menu'
              })

        } else {
          if (data.result === "sn_exists") {
            alert("This device has already been registered")
          } else {
            if (data.result === "invalid_sn") {
              alert("Serial number is not valid")
            }
          }

        }
      })

      xhr1.open('POST', 'http://3.21.222.196:3035/modify_settings');//87 is considered unsafe by Chrome
      xhr1.setRequestHeader("Content-Type", "application/json");
      console.log(this.state.sn)
      xhr1.send(JSON.stringify({
        sn: this.state.sn, location_desc: this.state.location, first_name: document.getElementById('first_name').value, last_name: document.getElementById('last_name').value,
        email: document.getElementById('email_address').value, phone_number: this.state.phone_number, business_name: this.state.business_name, street_address: this.state.street_address,
        city: this.state.city, state: this.state.state, zip_code: this.state.zip_code, country: this.state.country, timezone: this.state.timezone, location_type: this.state.location_type,
        number_people: this.state.number_people, reset_time: this.state.reset_time, number_songs: this.state.number_songs, song_start: this.state.song_start, song_end: this.state.song_end,
         start_time: this.state.start_time, stop_time: this.state.stop_time, camera_type: this.state.camera_type,
        rstp_address: this.state.rstp_address}));
    }
  }

  render() {

    return (
      <div className='container'>
        <div className="container3">
        <div className="header">
          <div className="menu1">
            <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
          </div>
          <div className="menu2"><a href="/#setup">Setup</a></div>
          <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
          <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
          <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
        </div>
        <div className="row">
          <center>
            <div className="col-12 col-s-12">

              <div className="col-12 col-s-12">
                <img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
                <p className="text_catch2">Modify Device Settings</p>
                <p className="text_required">All fields are required</p>

                <table className="table1">
                  <tbody>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" alt="" />Serial Number:
                        <span className="tooltiptext">Your serial number is found on the bottom of the device</span>
                        </div>
                      </td>
                      <td className="">

                      <select id="device_selector" name="device" size="1" onChange={this.update_fields}></select>
                      </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" alt="" />Location Name:
                        <span className="tooltiptext">Short location description</span>
                        </div>
                      </td>
                      <td className=""><input type="text" id="location" name="location" onChange={this.update_location}></input></td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>First Name:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="first_name" name="first_name" onChange={this.update_first_name}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Last Name:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="last_name" name="last_name" onChange={this.update_last_name}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Email Address:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="email_address" name="email_address" onChange={this.update_email}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Phone Number:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="phone_number" name="phone_number" onChange={this.update_phone_number}></input> </td>
                    </tr>
                    <tr>
                    <td className="form_text_left">
                      <div>Business Name:</div>
                    </td>
                    <td className="form_text_right"><input type="text" id="business_name" name="business_name" onChange={this.update_business_name}></input> </td>
                  </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Street Address:
                  <span className="tooltiptext">Address where your device is located</span>
                        </div>
                      </td>
                      <td className=""><input type="text" id="street_address" name="street_address" onChange={this.update_street_address}></input></td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>City:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="city" name="city" onChange={this.update_city}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>State:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="state" name="state" onChange={this.update_state}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Zip Code:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="zip_code" name="zip_code" onChange={this.update_zip_code}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Country:</div>
                      </td>
                      <td className="form_text_right"><input type="text" id="country" name="country" onChange={this.update_country}></input> </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Timezone:
                        <span className="tooltiptext">Timezone where your device is located</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="timezone" id="timezone" onChange={this.update_timezone}>
                          <option value="Africa/Johannesburg">Africa/Johannesburg</option>
                          <option value="America/New_York" selected>America/New York</option>
                          <option value="America/Chicago">America/Chicago</option>
                          <option value="America/Denver">America/Denver</option>
                          <option value="America/Los_Angeles">America/Los Angeles</option>
                          <option value="Europe/London">Europe/London</option>
                          <option value="Europe/Paris">Europe/Paris</option>
                          <option value="Europe/Berlin">Europe/Berlin</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Location Type:
                        <span className="tooltiptext">Type of location where your device is located</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="location_type" id="location_type" onChange={this.update_location_type}>
                          <option value="restaurant">Restaurant</option>
                          <option value="retail" selected>Retail</option>
                          <option value="office">Office</option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Number of people at this location per day:
                        <span className="tooltiptext">The number of people who visit this location per day</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="people_qty" id="people_qty" onChange={this.update_number_people}>
                          <option value="5">1 to 5</option>
                          <option value="20" selected>6 to 20</option>
                          <option value="50">21 to 50</option>
                          <option value="100">51 to 100</option>
                          <option value="200">101 to 200</option>
                          <option value="201">200+</option>
                        </select>
                      </td>
                    </tr>

                                        <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Reboot time:
                        <span className="tooltiptext">Time unit will automatically reboot if left running</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="reset_time" id="reset_time" onChange={this.update_reset_time}>
                          <option value="0:00">Midnight</option>
                          <option value="1:00">1:00 am</option>
                          <option value="2:00">2:00 am</option>
                          <option value="3:00">3:00 am</option>
                          <option value="4:00" selected>4:00 am</option>
                          <option value="5:00">5:00 am</option>
                          <option value="6:00">6:00 am</option>
                          <option value="7:00">7:00 am</option>
                          <option value="8:00">8:00 am</option>
                          <option value="9:00">9:00 am</option>
                          <option value="10:00">10:00 am</option>
                          <option value="11:00">11:00 am</option>
                          <option value="12:00">Noon</option>
                          <option value="13:00">1:00 pm</option>
                          <option value="14:00">2:00 pm</option>
                          <option value="15:00">3:00 pm</option>
                          <option value="16:00">4:00 pm</option>
                          <option value="17:00">5:00 pm</option>
                          <option value="18:00">6:00 pm</option>
                          <option value="19:00">7:00 pm</option>
                          <option value="20:00">8:00 pm</option>
                          <option value="21:00">9:00 pm</option>
                          <option value="22:00">10:00 pm</option>
                          <option value="23:00">11:00 pm</option>
                        </select>
                      </td>
                    </tr>



                                        <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Start Time:
                        <span className="tooltiptext">The time music will start and stop playing</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="start_time" id="start_time" onChange={this.update_start_time}>
                          <option value="0:00">Midnight</option>
                          <option value="1:00" >1:00 am</option>
                          <option value="2:00">2:00 am</option>
                          <option value="3:00">3:00 am</option>
                          <option value="4:00">4:00 am</option>
                          <option value="5:00">5:00 am</option>
                          <option value="6:00">6:00 am</option>
                          <option value="7:00" selected>7:00 am</option>
                          <option value="8:00">8:00 am</option>
                          <option value="9:00">9:00 am</option>
                          <option value="10:00">10:00 am</option>
                          <option value="11:00">11:00 am</option>
                          <option value="12:00">Noon</option>
                        </select>
                         <span className="form_text_right"> Stop Time: </span>
                        <select name="stop_time" id="stop_time" onChange={this.update_stop_time}>
                          <option value="13:00">1:00 pm</option>
                          <option value="14:00" >2:00 pm</option>
                          <option value="15:00">3:00 pm</option>
                          <option value="16:00">4:00 pm</option>
                          <option value="17:00">5:00 pm</option>
                          <option value="18:00">6:00 pm</option>
                          <option value="19:00">7:00 pm</option>
                          <option value="20:00" selected>8:00 pm</option>
                          <option value="21:00">9:00 pm</option>
                          <option value="22:00">10:00 pm</option>
                          <option value="23:00">11:00 pm</option>
                          <option value="0:00">Midnight</option>
                        </select>

                      </td>
                    </tr>


                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Number of songs per person:
                        <span className="tooltiptext">The number of songs played per person</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="number_songs" id="number_songs" onChange={this.update_number_songs}>
                          <option value="1">1</option>
                          <option value="2" >2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5" selected>5</option>

                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Music Library:
                        <span className="tooltiptext">Date range of songs played for random music</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="song_start" id="song_start" onChange={this.update_song_start}>
                          <option value="1960">1960's</option>
                          <option value="1970" >1970's</option>
                          <option value="1980" selected>1980's'</option>
                          <option value="1990">1990's</option>
                          <option value="2000">2000's</option>
                          <option value="2010">2010's</option>
                          <option value="2020">2020's</option>
                        </select>
                         <span className="form_text_right"> thru </span>
                        <select name="song_end" id="song_end" onChange={this.update_song_end}>
                          <option value="1969">1960's</option>
                          <option value="1979" >1970's</option>
                          <option value="1989">1980's</option>
                          <option value="1999" selected>1990's</option>
                          <option value="2009">2000's</option>
                          <option value="2019">2010's</option>
                          <option value="2024">today</option>
                        </select>

                      </td>
                    </tr>

                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Camera Type:
                        <span className="tooltiptext">Camera Type</span>
                        </div>
                      </td>
                      <td className="form_text_right">
                        <select name="camera_type" id="camera_type" onChange={this.update_camera_type}>
                          <option value="ip_cam" selected>Security Camera</option>
                          <option value="usb">Webcam</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" width="30" alt="" />Security camera RTSP address:
                        <span className="tooltiptext">Security camera RSTP address (if applicable)</span>
                        </div>
                      </td>
                      <td className="form_text_right"><input type="text" id="rstp_address" size="50" name="rstp_address" defaultValue="rtsp://username:password@192.168.1.xxx:554/live/ch0" onChange={this.update_rstp_address}></input> </td>
                    </tr>

                  </tbody>
                </table>
                <center>
                  <br></br><br></br><br></br>
                  <button onClick={this.handleClick}>Submit</button>
                  <br></br><br></br><br></br>
                </center>
                
              </div>

            </div>
          </center>
          
        </div>
        
        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
          <p className="text3">Pat. No. 11,232,469</p>
        <br></br>
        </div>
        </div>
      </div >
    );
  }
}